<template>
  <div class="clientManage">
    <div class="name">
      {{ moduleTitle }}
    </div>
    <div class="btns">
      <el-button
        type="primary"
        size="small"
        class="addGroup"
        @click="dialogAddVisible = true"
      >
        新建
      </el-button>
      <div class="searchBox">
        <el-input
          v-model.trim="searchValue"
          placeholder="支持搜索组名称"
          @keyup.enter.native="getGroupList(true)"
        ></el-input>
        <span class="iconBox" @click="getGroupList(true)">
          <i class="icon icon-search"></i>
        </span>
      </div>
    </div>

    <el-table :data="tableData" tooltip-effect="light" style="width: 100%">
      <el-table-column label="组ID" prop="groupId" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="组名称" prop="name" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="组管理员" prop="groupAdmin" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="操作"
        width="200px"
        align="center"
        class-name="options td-pt1"
      >
        <template slot-scope="scope">
          <span class="textBtn" @click="handleDetail(scope.row.id)">
            详情
          </span>
          <span class="textBtn delete" @click="handleDelete(scope.row.id)">
            删除
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :current-page.sync="pageNum"
      :total="total"
      @current-change="pageChange"
    >
    </el-pagination>
    <el-dialog
      title="删除提示"
      width="500px"
      :visible.sync="dialogRemoveOrAnable"
    >
      <div class="deleteText">确认删除这个组吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteGroup">确 定</el-button>
        <el-button @click="dialogRemoveOrAnable = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="新建组"
      width="600px"
      :visible.sync="dialogAddVisible"
      @close="handleCancel"
    >
      <group-info ref="groupInfo" :formGroup="formGroup"></group-info>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addGroup">确 定</el-button>
        <el-button @click="dialogAddVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/groupManage.js"
import groupInfo from "@/components//groupManage/groupInfo.vue"
export default {
  components: {
    groupInfo
  },
  data() {
    return {
      moduleTitle: "资源组",
      dialogRemoveOrAnable: false,
      tableData: [],
      breadcrumb: [
        {
          label: "资源组"
        }
      ],
      searchValue: null,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      realmName: this.$realm,
      currentGroupId: "",
      dialogAddVisible: false,
      formGroup: {
        groupId: "",
        groupAdmin: "",
        name: "",
        description: ""
      }
    }
  },
  mounted() {
    this.getGroupList()
  },
  methods: {
    // 查询组列表
    async getGroupList(type) {
      if(type) {
        this.pageNum = 1
      }
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        key: this.searchValue
      }
      let { status, data } = await APIS.getGroupList(this.realmName, {
        params
      })
      this.total = 0
      this.tableData = []
      if (status === 0) {
        this.total = data.totalCount || 0
        if (data && data.data) {
          this.tableData = data.data
        }
      }
    },
    // 删除组
    async deleteGroup() {
      let { status } = await APIS.deleteGroup(
        this.realmName,
        this.currentGroupId
      )
      this.dialogRemoveOrAnable = false
      if (status === 0) {
        if (this.total === 1) {
          this.pageNum = 1
        } else if ((this.total - 1) % this.pageSize === 0) {
          this.pageNum -= 1
        }
        this.getGroupList()
      }
    },
    // 翻页
    pageChange() {
      this.getGroupList()
    },
    // 新建组
    async addGroup() {
      let params = this.formGroup
      let validate = this.$refs["groupInfo"].validateForm()
      if (!validate) return false
      let { status } = await APIS.addGroup(this.realmName, {
        data: params
      })
      if (status === 0) {
        this.handleCancel()
        this.getGroupList()
      }
    },
    // 查看详情
    handleDetail(id) {
      this.$router.push({
        path: "/groupManage/detailGroup",
        query: {
          groupID: id
        }
      })
    },
    // 打开删除账户弹窗
    handleDelete(id) {
      this.currentGroupId = id
      this.dialogRemoveOrAnable = true
    },
    // 取消新建
    handleCancel() {
      this.dialogAddVisible = false
      this.$refs["groupInfo"].resetForm()
    }
  }
}
</script>

<style lang="scss">
.clientManage {
  .name {
    display: none; //暂时隐藏
  }
  .btns {
    margin: 0 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .searchBox {
      display: inline-flex;
      .iconBox {
        width: 30px;
        background-color: rgba(22, 155, 213, 1);
        flex-shrink: 0;
        text-align: center;
        line-height: 26px;
        cursor: pointer;
      }
    }
  }
}
</style>
